function trainerDisplayName(user) {
  return `${user.firstName || ''} ${user.lastName || ''}`.trim()
}

function isTrainer(user) {
  return user.roles && user.roles.includes('ROLE_TRAINER')
}

export function buildTrainerSelectOptions(users) {
  if (!Array.isArray(users)) {
    return []
  }
  return users
    .filter(isTrainer)
    .map(user => ({
      label: trainerDisplayName(user),
      value: user['@id'],
    }))
    .sort((a, b) => a.label.localeCompare(b.label, 'pl', { sensitivity: 'base' }))
}

export function buildDealerSelectOptions(dealers) {
  if (!dealers || !dealers['hydra:member']) {
    return []
  }
  return dealers['hydra:member'].map(dealer => ({
    label: dealer.name,
    value: dealer['@id'],
  }))
}
